/**
 * 文件日志观测api接口
 * @author： xuyd
 * @date：2022-01-12
 */
import request from "@/utils/request.js"

import {context} from '@/config/env.js'

const serviceModule = context.sunflower

export default {

  /**
   * 服务列表
   * @param params {Object}
   */
  selectGroupList: (params) => {
    return request.get(serviceModule + "/log/filelog/selectGroupList", {params});
  },

  /**
   * 日志文件列表
   * @param params
   */
  searchFileLogList: (params) => {
    return request.post(serviceModule + "/log/filelog/searchFileLogList", params);
  },

  /**
   * 日志内容grep 检索
   * @param params JSON {id, pageNum, pageSize}
   */
  searchFileLogContent: (params) => {
    return request.post(serviceModule + "/log/filelog/searchFileLogContent", params);
  },

  /**
   * 导出
   * @param params JSON { "id":213}
   */
  deleteFileLog: (params) => {
    return request.post(serviceModule + "/log/filelog/deleteFileLog", params);
  },

  /**
   * 导出
   * @param params JSON { "ids":[]}
   */
  downloadFileLog: (params) => {
    return request.download(serviceModule + "/log/filelog/downloadFileLog", params);
  },
}
